module.exports = __webpack_public_path__ + "img/p6.880e7046.png";